/* ============================================================
   HERCULES — PDP MOSAIC GALLERY JS
   Pairs with: assets/lp-pdp-mosaic.css

   Responsibilities:
   - On desktop, inject a "See more images" button into the
     media gallery if the product has >4 images
   - Toggle the .is-expanded state on the wrapper to reveal
     hidden images
   - Skip injection on mobile (handled by Swiper carousel)
   ============================================================ */

(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 1024;
  var INITIAL_VISIBLE = 4;

  function isDesktop() {
    return window.matchMedia('(min-width: ' + MOBILE_BREAKPOINT + 'px)').matches;
  }

  function findMosaicWrapper() {
    // The wrapper that gets .product--mosaic via section liquid
    return document.querySelector('.product--mosaic');
  }

  function findMediaList(wrapper) {
    return wrapper.querySelector('.product__media-list');
  }

  function getMediaCount(mediaList) {
    return mediaList.querySelectorAll(':scope > .swiper-slide').length;
  }

  function injectSeeMore(wrapper, mediaList) {
    // Don't inject twice
    if (mediaList.querySelector('.lp-mosaic__more')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lp-mosaic__more';
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML =
      '<span class="lp-mosaic__more-label">See more images</span>' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';

    btn.addEventListener('click', function () {
      var expanded = wrapper.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.querySelector('.lp-mosaic__more-label').textContent =
        expanded ? 'See fewer images' : 'See more images';
    });

    mediaList.appendChild(btn);
  }

  function removeSeeMore(mediaList) {
    var btn = mediaList.querySelector('.lp-mosaic__more');
    if (btn) btn.remove();
  }

  function init() {
    var wrapper = findMosaicWrapper();
    if (!wrapper) return;

    var mediaList = findMediaList(wrapper);
    if (!mediaList) return;

    var count = getMediaCount(mediaList);

    // Only inject the See More if desktop AND more than 4 images
    if (isDesktop() && count > INITIAL_VISIBLE) {
      injectSeeMore(wrapper, mediaList);
    } else {
      removeSeeMore(mediaList);
    }
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', debounce(init, 150));

  // Re-init on Shopify section reload in theme editor
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      setTimeout(init, 50);
    });
  }
})();